import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import type { Destination } from '../lib/destinations';

function tomorrowIso() {
  return new Date(Date.now() + 86400000).toISOString().slice(0, 10);
}

export function DestinationGrid({ items }: { items: Destination[] }) {
  const { t, i18n } = useTranslation();
  const isFa = i18n.language.startsWith('fa');
  const departureDate = tomorrowIso();

  return (
    <div className="dest-mosaic">
      {items.map((d, index) => {
        const city = isFa ? d.cityFa : d.cityEn;
        const region = isFa ? d.regionFa : d.regionEn;
        return (
          <Link
            key={d.code}
            to={`/search?origin=${d.code === 'IKA' ? 'MHD' : 'IKA'}&destination=${d.code}&departureDate=${departureDate}&cabin=economy`}
            className={`dest-tile dest-tile--${d.size}`}
            style={{ animationDelay: `${index * 60}ms` }}
          >
            <img src={d.image} alt={city} loading="lazy" />
            <div className="dest-tile__veil" aria-hidden="true" />
            <div className="dest-tile__meta">
              <span className="dest-tile__region">{region}</span>
              <div className="dest-tile__title-row">
                <h3>{city}</h3>
                {!isFa ? <span className="dest-tile__code">{d.code}</span> : null}
              </div>
              <span className="dest-tile__cta">{t('common.findFlight')}</span>
            </div>
          </Link>
        );
      })}
    </div>
  );
}
